/**
 * Consistent audio preprocessing utilities.
 * All functions operate on raw Float32 sample arrays or AudioBuffers.
 */

export function mixdownToMono(buffer: AudioBuffer): Float32Array {
  const channels = buffer.numberOfChannels;
  const length = buffer.length;
  const mono = new Float32Array(length);
  for (let i = 0; i < length; i++) {
    let sum = 0;
    for (let c = 0; c < channels; c++) {
      sum += buffer.getChannelData(c)[i];
    }
    mono[i] = sum / channels;
  }
  return mono;
}

export function peakNormalize(data: Float32Array): Float32Array {
  let max = 0;
  for (let i = 0; i < data.length; i++) {
    const a = Math.abs(data[i]);
    if (a > max) max = a;
  }
  if (max === 0) return new Float32Array(data);
  const out = new Float32Array(data.length);
  const scale = 1 / max;
  for (let i = 0; i < data.length; i++) {
    out[i] = data[i] * scale;
  }
  return out;
}

export function resampleLinear(data: Float32Array, origRate: number, targetRate: number): Float32Array {
  if (origRate === targetRate) return data;
  const ratio = origRate / targetRate;
  const newLen = Math.max(1, Math.floor(data.length / ratio));
  const out = new Float32Array(newLen);
  for (let i = 0; i < newLen; i++) {
    const pos = i * ratio;
    const idx = Math.floor(pos);
    const frac = pos - idx;
    const a = data[idx] ?? 0;
    const b = data[idx + 1] ?? a;
    out[i] = a + frac * (b - a);
  }
  return out;
}
